import type { ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { type BaseButtonProps, Button } from '@repo/design-system-kit/components/button/button';
import { IconArrowLeftOutlined } from '@repo/monochrome-icons';

export interface BackButtonSimpleProps extends Omit<BaseButtonProps, 'children'> {
  onPress: () => void;
  label?: string;
}

export function BackButtonSimple({ onPress, label, ...props }: BackButtonSimpleProps): ReactNode {
  const intl = useIntl();
  const text = intl.formatMessage({ id: 'identity-verification-kit.btn.back' });

  return (
    <Button
      aria-label={text}
      iconLeft={<IconArrowLeftOutlined aria-hidden="true" />}
      label={label ?? text}
      onPress={onPress}
      type="button"
      variant="tertiary"
      {...props}
    />
  );
}
